import { DatePicker } from "../core/DatePicker";
import { useTranslation } from "react-i18next";
import type { QuestionDictoinary } from "../../utils/patientQuestions";

export function PatientQuestionInput({
  input,
  onChange,
}: {
  input: QuestionDictoinary[string];
  onChange: (value: string) => void;
}) {
  const { t } = useTranslation();
  if (input.type === "select") {
    return (
      <select
        className="-mt-1 h-12 w-full rounded-full border px-4"
        value={input.value}
        onChange={(event) => onChange(event.target.value)}
        required={input.required}
      >
        <option value="">{t("Bitte auswählen")}</option>
        {input.options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    );
  }
  if (input.type === "date") {
    return (
      <div>
        <DatePicker value={input.value} name="date" onChange={onChange} autoFocus={false} />
        <p className="px-2 pt-1 text-center text-xs text-gray-500">
          {t("Das Geburtsdatum muss im Format DD.MM.YYYY eingetragen werden.")}
        </p>
      </div>
    );
  }
  return (
    <input
      className="h-12 w-full rounded-full border px-4"
      type={input.type}
      value={input.value}
      onChange={(event) => onChange(event.target.value)}
      required={input.required}
      min={input.type === "number" ? input.min : undefined}
      max={input.type === "number" ? input.max : undefined}
      title={input.title}
      placeholder={input.placeholder}
      autoFocus={input.key === "first_name"}
    />
  );
}
